import Graph from "../model/API/graph";

export const graphDetails: Graph = {
    daily:
        {
            "6h": 0,
            "9h": 0,
            "12h":0,
            "15h":0,
            "18h":0,
            "21h":0,
            "00h":0
        },
    average:{
            "6h": 0,
            "9h": 0,
            "12h":0,
            "15h":0,
            "18h":0,
            "21h":0,
            "00h":0
    }
}

